import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	ai_debugger_icon_label: {
		id: 'search_ai.ai_debugger_icon_label',
		defaultMessage: 'Debugger',
		description: 'Label for debugger icon',
	},
	ai_debugger_modal_title: {
		id: 'search_ai.ai_debugger_modal_title',
		defaultMessage: 'SAIN Debugging Panel',
		description: 'Title for debugging modal',
	},
	ai_debugger_modal_original_query_subheading: {
		id: 'search_ai.ai_debugger_modal_original_query_subheading',
		defaultMessage: 'Original Query',
		description: 'Subheading for original query',
	},
	ai_debugger_modal_transformed_query_subheading: {
		id: 'search_ai.ai_debugger_modal_transformed_query_subheading',
		defaultMessage: 'Transformed Query',
		description: 'Subheading for transformed query',
	},
	ai_debugger_modal_detected_intent_subheading: {
		id: 'search_ai.ai_debugger_modal_detected_intent_subheading',
		defaultMessage: 'Detected Intent',
		description: 'Subheading for detected intent',
	},
	ai_debugger_modal_trace_id_subheading: {
		id: 'search_ai.ai_debugger_modal_trace_id_subheading',
		defaultMessage: 'Trace ID',
		description: 'Subheading for trace ID',
	},
	ai_debugger_modal_model_subheading: {
		id: 'search_ai.ai_debugger_modal_model_subheading',
		defaultMessage: 'Answer Generation Model',
		description: 'Subheading for model',
	},
	ai_debugger_modal_sources_subheading: {
		id: 'search_ai.ai_debugger_modal_sources_subheading',
		defaultMessage: 'Sources',
		description: 'Subheading for sources',
	},
	ai_debugger_modal_cached_answer_subheading: {
		id: 'search_ai.ai_debugger_modal_cached_answer_subheading',
		defaultMessage: 'Cached answer',
		description: 'Subheading for cached answer',
	},
	ai_debugger_modal_copy_button_text: {
		id: 'search_ai.ai_debugger_modal_copy_button_text',
		defaultMessage: 'Copy JSON',
		description: 'Text for copy button',
	},
	ai_debugger_modal_copy_button_copied_text: {
		id: 'search_ai.ai_debugger_modal_copy_button_copied_text',
		defaultMessage: 'JSON Copied',
		description: 'Text for copy button after JSON is copied',
	},
	ai_debugger_modal_tab_request_overview: {
		id: 'search_ai.ai_debugger_modal_tab_request_overview',
		defaultMessage: 'Request Overview',
		description: 'Label for request overview tab',
	},
	ai_debugger_modal_tab_raw_search_results: {
		id: 'search_ai.ai_debugger_modal_tab_raw_search_results',
		defaultMessage: 'Raw Search Results',
		description: 'Label for raw search results tab',
	},
	ai_debugger_modal_tab_ranked_search_results: {
		id: 'search_ai.ai_debugger_modal_tab_ranked_search_results',
		defaultMessage: 'Ranked Search Results',
		description: 'Label for raw search results tab',
	},
	ai_debugger_modal_tab_plugin_invocations: {
		id: 'search_ai.ai_debugger_modal_tab_plugin_invocations',
		defaultMessage: 'Plugin Invocations',
		description: 'Label for plugin invocations tab',
	},
	ai_debugger_modal_tab_raw_json: {
		id: 'search_ai.ai_debugger_modal_tab_raw_json',
		defaultMessage: 'Raw JSON',
		description: 'Label for raw JSON tab',
	},
	ai_debugger_modal_copy_trace_id_label: {
		id: 'search_ai.ai_debugger_modal_copy_trace_id_label',
		defaultMessage: 'Copy Trace ID',
		description: 'Label for copy Trace ID button',
	},
	ai_debugger_modal_trace_id_copied_text: {
		id: 'search_ai.ai_debugger_modal_trace_id_copied_text',
		defaultMessage: 'Trace ID copied',
		description: 'Text for Trace ID copied',
	},
	ai_debugger_modal_expand_label: {
		id: 'search_ai.ai_debugger_modal_expand_label',
		defaultMessage: 'Expand',
		description: 'Label for expand button',
	},
	ai_debugger_modal_collapse_label: {
		id: 'search_ai.ai_debugger_modal_collapse_label',
		defaultMessage: 'Collapse',
		description: 'Label for collapse button',
	},
	ai_debugger_modal_success_label: {
		id: 'search_ai.ai_debugger_modal_success_label',
		defaultMessage: 'Success',
		description: 'Label for success status',
	},
	ai_debugger_modal_failed_label: {
		id: 'search_ai.ai_debugger_modal_failed_label',
		defaultMessage: 'Failed',
		description: 'Label for failed status',
	},
	ai_debugger_modal_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_search_results_heading',
		defaultMessage: 'Search Results ({count})',
		description: 'Heading for search results section with count',
	},
	ai_debugger_modal_ranked_documents_heading: {
		id: 'search_ai.ai_debugger_modal_ranked_documents_heading',
		defaultMessage: 'Ranked Documents ({count})',
		description: 'Heading for ranked documents section with count',
	},
	ai_debugger_modal_tab_orchestration_overview: {
		id: 'search_ai.ai_debugger_modal_tab_orchestration_overview',
		defaultMessage: 'Orchestration Overview',
		description: 'Label for orchestration overview tab',
	},
	ai_debugger_modal_tab_loop: {
		id: 'search_ai.ai_debugger_modal_tab_loop',
		defaultMessage: 'Loop {number}',
		description: 'Label for loop tab with number',
	},
	ai_debugger_modal_orchestration_loop_heading: {
		id: 'search_ai.ai_debugger_modal_orchestration_loop_heading',
		defaultMessage: 'Loop {number}',
		description: 'Heading for orchestration loop',
	},
	ai_debugger_modal_orchestration_loop_with_count: {
		id: 'search_ai.ai_debugger_modal_orchestration_loop_with_count',
		defaultMessage: 'Loop {number} - {count} {count, plural, one {minion} other {minions}}',
		description: 'Heading for orchestration loop with minion count',
	},
	ai_debugger_modal_orchestration_minions_count: {
		id: 'search_ai.ai_debugger_modal_orchestration_minions_count',
		defaultMessage: '{count} {count, plural, one {minion} other {minions}}',
		description: 'Count of minions in a loop',
	},
	ai_debugger_modal_no_orchestration_data: {
		id: 'search_ai.ai_debugger_modal_no_orchestration_data',
		defaultMessage: 'No minion outputs to show.',
		description: 'Text shown when no minion outputs are available',
	},
	ai_debugger_modal_minion_input_label: {
		id: 'search_ai.ai_debugger_modal_minion_input_label',
		defaultMessage: 'Input',
		description: 'Label for minion input field',
	},
	ai_debugger_modal_minion_output_label: {
		id: 'search_ai.ai_debugger_modal_minion_output_label',
		defaultMessage: 'Output',
		description: 'Label for minion output field',
	},
	ai_debugger_modal_execution_duration: {
		id: 'search_ai.ai_debugger_modal_execution_duration',
		defaultMessage: '{duration}ms',
		description: 'Execution duration in milliseconds',
	},
	ai_debugger_modal_execution_duration_label: {
		id: 'search_ai.ai_debugger_modal_execution_duration_label',
		defaultMessage: 'Duration',
		description: 'Label for execution duration',
	},
	ai_debugger_modal_minion_name_label: {
		id: 'search_ai.ai_debugger_modal_minion_name_label',
		defaultMessage: 'Minion Name',
		description: 'Label for minion name column',
	},
	ai_debugger_modal_disabled: {
		id: 'search_ai.ai_debugger_modal_disabled',
		defaultMessage: 'disabled',
		description: 'Text shown when a value is not available',
	},
	ai_debugger_modal_minion_extra_info_label: {
		id: 'search_ai.ai_debugger_modal_plugin_output_label',
		defaultMessage: 'Extra Info',
		description: 'Label for minion extra info section',
	},
	ai_debugger_modal_no_plugins_invoked: {
		id: 'search_ai.ai_debugger_modal_no_plugins_invoked',
		defaultMessage: 'No additional plugins invoked.',
		description: 'Text shown when no additional plugins were invoked',
	},
	ai_debugger_modal_teamwork_unnamed_team: {
		id: 'search_ai.ai_debugger_modal_teamwork_unnamed_team',
		defaultMessage: 'Unnamed Team',
		description: 'Fallback name for a team without a name',
	},
	ai_debugger_modal_teamwork_members_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_members_count',
		defaultMessage: 'Members: {count}',
		description: 'Label for team members count',
	},
	ai_debugger_modal_teamwork_state: {
		id: 'search_ai.ai_debugger_modal_teamwork_state',
		defaultMessage: 'State: {state}',
		description: 'Label for team state',
	},
	ai_debugger_modal_teamwork_creator: {
		id: 'search_ai.ai_debugger_modal_teamwork_creator',
		defaultMessage: 'Creator: {creator}',
		description: 'Label for team creator',
	},
	ai_debugger_modal_teamwork_show_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_show_count',
		defaultMessage: 'Show {count} {count, plural, one {member} other {members}}',
		description: 'Text for showing member count',
	},
	ai_debugger_modal_teamwork_hide_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_hide_count',
		defaultMessage: 'Hide {count} {count, plural, one {member} other {members}}',
		description: 'Text for hiding member count',
	},
	ai_debugger_modal_author_label: {
		id: 'search_ai.ai_debugger_modal_author_label',
		defaultMessage: 'Author: {author}',
		description: 'Label for author field',
	},
	ai_debugger_modal_teamwork_document_updated: {
		id: 'search_ai.ai_debugger_modal_teamwork_document_updated',
		defaultMessage: 'Updated: {date}',
		description: 'Label for document updated date',
	},
	ai_debugger_modal_page_search_space: {
		id: 'search_ai.ai_debugger_modal_page_search_space',
		defaultMessage: 'Space: {space}',
		description: 'Label for page search space',
	},
	ai_debugger_modal_page_search_count: {
		id: 'search_ai.ai_debugger_modal_page_search_count',
		defaultMessage: '{count} {count, plural, one {page} other {pages}} found',
		description: 'Count of pages found in page search',
	},
	ai_debugger_modal_function_results_count: {
		id: 'search_ai.ai_debugger_modal_function_results_count',
		defaultMessage: 'Function Results ({count})',
		description: 'Label for function results with count',
	},
	ai_debugger_modal_raw_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_raw_search_results_heading',
		defaultMessage: '{count, plural, one {Raw Search Result ({count})} other {Raw Search Results ({count})}}',
		description: 'Heading for raw search results section with count, pluralized',
	},
	ai_debugger_modal_table_url_header: {
		id: 'search_ai.ai_debugger_modal_table_url_header',
		defaultMessage: 'Document URL',
		description: 'Table header for URL column',
	},
	ai_debugger_modal_table_doc_index_header: {
		id: 'search_ai.ai_debugger_modal_table_doc_index_header',
		defaultMessage: '#',
		description: 'Table header for document index/ranking column',
	},
	ai_debugger_modal_no_raw_search_results: {
		id: 'search_ai.ai_debugger_modal_no_raw_search_results',
		defaultMessage: 'No raw search results available.',
		description: 'Text shown when no raw search results are available',
	},
	ai_debugger_modal_ranked_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_ranked_search_results_heading',
		defaultMessage: '{count, plural, one {Ranked Document with Chunks ({count})} other {Ranked Documents with Chunks ({count})}}',
		description: 'Heading for ranked search results section with count, pluralized',
	},
	ai_debugger_modal_table_chunk_id_header: {
		id: 'search_ai.ai_debugger_modal_table_chunk_id_header',
		defaultMessage: 'Chunk ID',
		description: 'Table header for chunk ID column',
	},
	ai_debugger_modal_table_chunk_score_header: {
		id: 'search_ai.ai_debugger_modal_table_chunk_score_header',
		defaultMessage: 'Score',
		description: 'Table header for chunk score column',
	},
	ai_debugger_modal_table_chunk_rank_header: {
		id: 'search_ai.ai_debugger_modal_table_chunk_rank_header',
		defaultMessage: 'Rank',
		description: 'Table header for chunk rank column',
	},
	ai_debugger_modal_no_ranked_search_results: {
		id: 'search_ai.ai_debugger_modal_no_ranked_search_results',
		defaultMessage: 'No ranked search results available.',
		description: 'Text shown when no ranked search results are available',
	},
	ai_debugger_modal_unable_to_match_chunks: {
		id: 'search_ai.ai_debugger_modal_unable_to_match_chunks',
		defaultMessage: 'Unable to match chunks',
		description: 'Text shown when unable to match chunks for a document',
	},
	ai_debugger_modal_plugins_invoked_subheading: {
		id: 'search_ai.ai_debugger_modal_plugins_invoked_subheading',
		defaultMessage: 'Plugins Invoked',
		description: 'Subheading for plugins invoked section',
	},
	prompt_override_button_label: {
		id: 'search_ai.prompt_override_button_label',
		defaultMessage: 'Prompt override',
		description: 'Label for prompt override button',
	},
	prompt_override_modal_title: {
		id: 'search_ai.prompt_override_modal_title',
		defaultMessage: 'Custom System Prompt Override',
		description: 'Title for prompt override modal',
	},
	prompt_override_custom_prompt_label: {
		id: 'search_ai.prompt_override_custom_prompt_label',
		defaultMessage: 'Custom Prompt:',
		description: 'Label for custom prompt text area',
	},
	prompt_override_textarea_placeholder: {
		id: 'search_ai.prompt_override_textarea_placeholder',
		defaultMessage: 'Enter your custom system prompt here...',
		description: 'Placeholder text for custom prompt text area',
	},
	prompt_override_help_text: {
		id: 'search_ai.prompt_override_help_text',
		defaultMessage:
			'This prompt will override the default system prompt for AI requests during this session.',
		description: 'Help text explaining the prompt override functionality',
	},
	prompt_override_cancel_button: {
		id: 'search_ai.prompt_override_cancel_button',
		defaultMessage: 'Cancel',
		description: 'Text for cancel button in prompt override modal',
	},
	prompt_override_save_button: {
		id: 'search_ai.prompt_override_save_button',
		defaultMessage: 'Save',
		description: 'Text for save button in prompt override modal',
	},
});
